import { toast } from 'bulma-toast';
import { reactive } from 'vue';

export const poollingStore = reactive({
    HasRequestsPedentes: false,
    RequestsPendentes: [],
    PoollingInterval: null,
    Modulo: '',
    PoollingToast: (message, type) => toast({
        message: `<div style="overflow: auto; max-height:50vh">${message}</div>`,
        type: type,
        duration: 3600000,
        position: 'top-right',
        dismissible: true
    }),

    UpdateRequestsPendentes() {
        let requestsLocalStorage = JSON.parse(window.localStorage.getItem('requests-pendentes'));
        this.Modulo = window.localStorage.getItem('modulo');
        this.RequestsPendentes = Array.isArray(requestsLocalStorage)? requestsLocalStorage : [];

        if(this.RequestsPendentes.length == 0) {
            this.HasRequestsPedentes = false;
            return;
        } else {
            this.HasRequestsPedentes = true;
            return;
        }
    },

    AddRequestPendente(objeto) {
        if(!objeto.uuid) return;
        this.RequestsPendentes.push(objeto.uuid);
        this.Modulo = objeto.modulo;
        const requestsAsString = JSON.stringify(this.RequestsPendentes);
        window.localStorage.setItem('requests-pendentes', requestsAsString);
        window.localStorage.setItem('modulo', objeto.modulo);
        this.UpdateRequestsPendentes();

        // Descomentar quando for evoluir (Comentado pois dava problema com o reload)
        // if(this.PoollingInterval == null && this.HasRequestsPedentes) {
        //     this.StartPoolling();
        // }
    },

    RemoveRequestPendente(id) {
        if(!id) return;
        const requestIndex = this.RequestsPendentes.indexOf(id);
        if (requestIndex != undefined) {
            this.RequestsPendentes.splice(requestIndex, 1);
            const requestsAsString = JSON.stringify(this.RequestsPendentes);
            window.localStorage.setItem('requests-pendentes', requestsAsString);
            this.UpdateRequestsPendentes();
            if(this.RequestsPendentes.length == 0) {
                this.StopPoolling();
            }
        }
    },

    StartPoolling(timeout = 60000) {
        this.UpdateRequestsPendentes();
        if(this.HasRequestsPedentes) {
            if (this.Modulo == 'grupo-tarefas') {
                this.PoollingToast('A vinculação da(s) tarefa(s) à(s) empresa(s) correspondente(s) pode levar alguns minutos. Enviaremos uma notificação quando a vinculação for concluída.','is-info');
            } else if (this.Modulo == 'grupo-tarefas-exclusao') {
                this.PoollingToast('A remoção da(s) tarefa(s) à(s) empresa(s) correspondente(s) pode levar alguns minutos. Enviaremos uma notificação quando a remoção for concluída.','is-info');
            } else if (this.Modulo == 'grupo-tarefas-inclusao-exclusao') {
                this.PoollingToast('A vinculação e remoção da(s) tarefa(s) à(s) empresa(s) correspondente(s) pode levar alguns minutos. Enviaremos uma notificação quando a inclusão e a remoção forem concluídas.','is-info');
            } else if (this.Modulo == 'importacao') {
                this.PoollingToast('A importação de tarefas pode levar alguns minutos. Enviaremos uma notificação quando a importação for concluída.','is-info');
            }

            this.ExecutePoolling(timeout).then(() => {
                if(this.HasRequestsPedentes) {
                    this.PoollingInterval = setInterval(async () => {
                        this.UpdateRequestsPendentes();
                        await this.ExecutePoolling(timeout);
                    },timeout)
                }
            }).catch(e => {
                if (this.Modulo == 'grupo-tarefas') {
                    this.PoollingToast('Falha ao realizar a vinculação','is-danger');
                } else if (this.Modulo == 'grupo-tarefas-inclusão-exclusao') {
                    this.PoollingToast('Falha ao realizar a inclusão e remoção','is-danger');
                } else if (this.Modulo == 'grupo-tarefas-exclusao') {
                    this.PoollingToast('Falha ao realizar a remoção','is-danger');
                } else {
                    this.PoollingToast('Falha ao realizar o envio.','is-danger');
                }

            })
        }
    },

    async ExecutePoolling() {
        if(!this.HasRequestsPedentes) return;
        const { uploadDeTarefasService } = await import('../views/CadastroTarefas/service/upload-tarefas-service');
        const { service } = await import('../views/GrupoDeTarefas/service/grupo-de-tarefas-service');
        this.RequestsPendentes.forEach(async(id) => {
            if (this.Modulo == 'grupo-tarefas-inclusao-exclusao') {
                let request = await service.adquirirStatusVinculacoes(id);
                switch (`${request?.message} | ${request?.messageExclusao}`) {
                    case "Vinculação realizada com sucesso! | Remoção realizada com sucesso!":
                        this.PoollingToast('A vinculação e a remoção foram realizadas com sucesso!','is-success');
                        this.RemoveRequestPendente(id);
                        return;
                }
                switch(request?.message) {
                    case "Vinculação realizada com sucesso!":
                        this.PoollingToast('Vinculação realizada com sucesso!','is-success');
                        this.RemoveRequestPendente(id);
                        break;
                    case "Falha ao realizar a vinculação":
                        this.PoollingToast('Falha ao realizar a vinculação.','is-danger');
                        this.RemoveRequestPendente(id);
                        break;
                    case "Algumas tarefas apresentaram erro na vinculação.":
                        let listagemDeTarefasNaoVinculadasLista = '';
                        request?.tarefasNaoVinculadas?.forEach(msg => {
                            listagemDeTarefasNaoVinculadasLista = listagemDeTarefasNaoVinculadasLista + `${msg}\n`
                        })
                        this.PoollingToast(`As tarefas listadas abaixo não foram vinculadas às empresas devido ao seu cadastro incompleto. Por favor, verifique o cadastro da tarefa e tente novamente.\n ${listagemDeTarefasNaoVinculadasLista}`,'is-warning');
                        this.RemoveRequestPendente(id);
                        break;
                };
                switch(request?.messageExclusao) {
                    case "Erro na remoção de tarefas.":
                        let listagemDeTarefasNaoRemovidas = '';
                        let listagemDeEmpresas = '';
                        request.tarefasNaoRemovidas.forEach(msg => {
                            listagemDeTarefasNaoRemovidas = listagemDeTarefasNaoRemovidas + `${msg.nome}\n`
                        })
                        request?.listagemDeEmpresas.forEach(msg => {
                            listagemDeEmpresas = listagemDeEmpresas + `${msg.nome}\n`
                        })
                        this.PoollingToast(`As empresa(s) listada(s) abaixo não foram removida(s) do vínculo da(s) tarefa(s) também listada(s) abaixo,\n pois identificamos que existe um ou mais grupos de tarefas que possuem essa(s) tarefa(s) e empresa(s) vinculada(s):<strong>Empresa(s):</strong>${listagemDeEmpresas}\r<strong>Tarefa(s):</strong>${listagemDeTarefasNaoRemovidas}`,'is-warning');
                        this.RemoveRequestPendente(id);
                        break;
                    case "Remoção realizada com sucesso!":
                        let mensagemExclusao = request?.messageComplementar == null ? request?.messageExclusao : request?.messageExclusao + "</br></br>" + request?.messageComplementar;
                        let corAletar = request?.messageComplementar == null ? 'is-success' : 'is-warning';
                        this.PoollingToast(mensagemExclusao,corAletar);
                        this.RemoveRequestPendente(id);
                        break;
                };
            } else if (this.Modulo == 'grupo-tarefas') {
                let request = await service.adquirirStatusVinculacoes(id);
                switch(request?.message) {
                    case "Vinculação realizada com sucesso!":
                        this.PoollingToast('Vinculação realizada com sucesso!','is-success');
                        this.RemoveRequestPendente(id);
                        break;
                    case "Falha ao realizar a vinculação":
                        this.PoollingToast('Falha ao realizar a vinculação.','is-danger');
                        this.RemoveRequestPendente(id);
                        break;
                    case "Algumas tarefas apresentaram erro na vinculação.":
                        let listagemDeTarefasNaoVinculadasLista = '';
                        request.tarefasNaoVinculadas.forEach(msg => {
                            listagemDeTarefasNaoVinculadasLista = listagemDeTarefasNaoVinculadasLista + `${msg}\n`
                        })
                        this.PoollingToast(`As tarefas listadas abaixo não foram vinculadas às empresas devido ao seu cadastro incompleto. Por favor, verifique o cadastro da tarefa e tente novamente.\n ${listagemDeTarefasNaoVinculadasLista}`,'is-warning');
                        this.RemoveRequestPendente(id);
                        break;
                };
            } else if (this.Modulo == 'grupo-tarefas-exclusao') {
                let request = await service.adquirirStatusVinculacoes(id);
                switch(request?.messageExclusao) {
                    case "Erro na remoção de tarefas.":
                        let listagemDeTarefasNaoRemovidas = '';
                        let listagemDeEmpresas = '';
                        request.tarefasNaoRemovidas.forEach(msg => {
                            listagemDeTarefasNaoRemovidas = listagemDeTarefasNaoRemovidas + `${msg.nome}\n`
                        })
                        request.listagemDeEmpresas.forEach(msg => {
                            listagemDeEmpresas = listagemDeEmpresas + `${msg.nome}\n`
                        })
                        this.PoollingToast(`As empresa(s) listada(s) abaixo não foram removida(s) do vínculo da(s) tarefa(s) também listada(s) abaixo,\n pois identificamos que existe um ou mais grupos de tarefas que possuem essa(s) tarefa(s) e empresa(s) vinculada(s):<strong>Empresa(s):</strong>${listagemDeEmpresas}\r<strong>Tarefa(s):</strong>${listagemDeTarefasNaoRemovidas}`,'is-warning');
                        this.RemoveRequestPendente(id);
                        break;
                    case "Remoção realizada com sucesso!":
                      let mensagemExclusao = request?.messageComplementar == null ? request?.messageExclusao : request?.messageExclusao + "</br>" + request?.messageComplementar;
                      let corAletar = request?.messageComplementar == null ? 'is-success' : 'is-warning';
                      this.PoollingToast(mensagemExclusao,corAletar);
                      this.RemoveRequestPendente(id);
                      break;
                }
            } else if (this.Modulo == 'importacao') {
                let request = await uploadDeTarefasService.adquirirStatusImportacoes(id);
                switch(request?.message) {
                    case "Falha ao realizar o envio":
                        this.PoollingToast('Falha ao realizar o envio.','is-danger');
                        this.RemoveRequestPendente(id);
                        break;
                    case "Algumas tarefas apresentaram erro na criação.":
                        let listagemDeArquivosComErro = '';
                        request.tarefasNaoCadastradas.forEach(msg => {
                            listagemDeArquivosComErro = listagemDeArquivosComErro + `${msg}\n`
                        })
                        this.PoollingToast(`As tarefas listadas abaixo não foram cadastradas, pois alguns dados informados no Excel não foram identificados pelo sistema:\n ${listagemDeArquivosComErro}`,'is-warning');
                        this.RemoveRequestPendente(id);
                        break;
                    case "Todas as tarefas foram cadastradas com sucesso.":
                        this.PoollingToast('Todas as tarefas foram cadastradas com sucesso.','is-success');
                        this.RemoveRequestPendente(id);
                        break;
                };
            }
        });
        this.UpdateRequestsPendentes();
        if(this.PoollingInterval != null && !this.HasRequestsPedentes) {
            this.StopPoolling();
        }
    },

    StopPoolling() {
        this.UpdateRequestsPendentes();
        if(this.PoollingInterval != null) {
            clearInterval(this.PoollingInterval);
            this.PoollingInterval = null;
        }
    }
})
